import React, { useState } from 'react';

// Mui Components
import Divider from '@mui/material/Divider';

// Local Components
import CustomAccordion from '../Filtering/CustomAccordion';

// Utils - Currency
import { ccyFormat } from '../../utils/currencyFormatter';

// Image
import DemoSvg from '../../assets/images/Discord.png';

// Typography
import { H6, Body2, Body3, Body1 } from '../../themes/typography';

// Button
import { SecondaryBtn } from '../Buttons/Buttons';

// CSS
import '../../styles/components/OrderSummary.css';

export default function OrderSummary({
    subTotal,
    totalQty,
    taxesBreakup,
    bookingFees,
    showFeesTable,
    tax,
    netTotal,
    children
}) {
    const [showTaxesBreakup, setShowTaxesBreakup] = useState(false);

    const [appliedCoupons, setAppliedCoupons] = useState({});

    const [discount, setDiscount] = useState({
        discountName: '',
        discountAmount: '',
        discountPercentage: ''
    });

    const coupanCodes = [
        {
            coupanCode: 'SHMOOZ',
            discountPercentage: 20,
            discountAmount: 200
        }
        // {
        //     coupanCode: 'NEW5',
        //     discountPercentage: 20,
        //     discountAmount: 200,
        // },
        // {
        //     coupanCode: 'REACT',
        //     discountPercentage: 20,
        //     discountAmount: 200,
        // }
    ];

    function applyDiscount(coupan) {
        setDiscount({
            discountName: coupan.coupanCode,
            discountAmount: coupan.discountAmount,
            discountPercentage: coupan.discountPercentage
        });
        setAppliedCoupons((prev) => ({ ...prev, [coupan.coupanCode]: true })); // tracks the clicks coupan code and mark them as Applied
    }

    // console.log(appliedCoupons)

    function toggleTaxesBreakup() {
        setShowTaxesBreakup(!showTaxesBreakup);
    }

    return (
        <React.Fragment>
            <div className="final-ticket-order-summary-container">
                {/* coupan code section */}
                <section className="ticket-coupen-code-section">
                    <CustomAccordion accordtionTitle="Apply Discount" darkMode>
                        <div className="appply-discount-container">
                            {coupanCodes.length > 0 && (
                                <div
                                    className="no-coupan-code-found-image"
                                    style={{ width: '100%' }}
                                >
                                    <img
                                        src={DemoSvg}
                                        alt="No Coupan Code Found"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            )}

                            {coupanCodes.map((coupan, index) => {
                                return (
                                    <div key={index} className="apply-coupan-code-container">
                                        <div className="discount-related-details-container">
                                            <Body2>{coupan.coupanCode}</Body2>
                                            <Body3>
                                                Get {coupan.discountPercentage}% off on all tickets
                                            </Body3>
                                            <Body3>+ Terms & Condition</Body3>
                                        </div>
                                        <div className="apply-discount-button-container">
                                            <SecondaryBtn
                                                name={
                                                    appliedCoupons[coupan.coupanCode]
                                                        ? 'Applied'
                                                        : 'Apply'
                                                }
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    applyDiscount(coupan);
                                                }}
                                                disabled={appliedCoupons[coupan.coupanCode]}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </CustomAccordion>
                </section>

                {/* ticket order summary section */}
                <section className="ticket-order-summary-section">
                    <H6 color="#F8A21E">Order Summary</H6>

                    <Divider sx={dividerStyle} />

                    {/* total number of ticket section */}
                    <div className="ticket-order-calculation-section">
                        <div className="order-summary-row">
                            <div className="order-summary-row-title">
                                <Body1>Total Quantity</Body1>
                            </div>
                            <div className="order-summary-row-amount">
                                <Body1 color="#F8A21E">{totalQty}</Body1>
                            </div>
                        </div>

                        {/* ticket subtotal section */}
                        <div className="order-summary-row">
                            <div className="order-summary-row-title">
                                <Body1>Sub Total</Body1>
                            </div>
                            <div className="order-summary-row-amount">
                                <Body1 color="#F8A21E">{ccyFormat(subTotal)}</Body1>
                            </div>
                        </div>

                        {/* Taxes with breakup section */}
                        <div className="taxes-with-breakup-container">
                            <div className="taxes-row">
                                <div className="taxes-title">
                                    <Body1>Taxes</Body1>
                                </div>
                                <div className="taxes-amount">
                                    <Body1 color="#F8A21E">{ccyFormat(tax)}</Body1>
                                </div>
                            </div>
                            <div className="show-breakup-link" onClick={toggleTaxesBreakup}>
                                <Body3 style={{ cursor: 'pointer' }}>Show Breakup</Body3>
                            </div>
                            {showTaxesBreakup && (
                                <div className="taxes-breakup-container">
                                    {taxesBreakup.map((tax, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className="taxes-breakup-additional-row"
                                            >
                                                <div className="taxes-breakup-title">
                                                    <Body3>{tax.title}</Body3>
                                                </div>
                                                <div className="taxes-breakup-amount">
                                                    <Body3>{ccyFormat(tax.amount)}</Body3>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* booking fees with breakup section */}
                        <div className="taxes-with-breakup-container">
                            <div className="taxes-row">
                                <div className="taxes-title">
                                    <Body1>Fees</Body1>
                                </div>
                                <div className="taxes-amount">
                                    {/* Fees Amount will be booking fees + platform fees */}
                                    {/* Todo */}
                                    <Body1 color="#F8A21E">{ccyFormat(bookingFees)}</Body1>
                                </div>
                            </div>
                            <div className="show-breakup-link" onClick={showFeesTable}>
                                <Body3 style={{ cursor: 'pointer' }}>Show Breakup</Body3>
                            </div>
                        </div>

                        {/* Coupan code amount apply section */}
                        {discount.discountName !== '' && (
                            <div className="taxes-with-breakup-container">
                                <div className="taxes-row">
                                    <div className="taxes-title">
                                        <Body1>{discount.discountName}</Body1>
                                    </div>
                                    <div className="taxes-amount">
                                        <Body1 color="#F8A21E">
                                            {ccyFormat(discount.discountAmount)}
                                        </Body1>
                                    </div>
                                </div>
                                <div className="show-breakup-link">
                                    <Body3 style={{ cursor: 'pointer' }}>
                                        {`${discount.discountPercentage}% Discount Applied`}
                                    </Body3>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* total calculation section */}
                    <div className="ticket-order-calculate-total-section">
                        <H6>Total :</H6>
                        <H6 color="#F8A21E">₹{netTotal}</H6>
                    </div>

                    <Divider sx={dividerStyle} />

                    <div className="ticket-order-terms-section">{children}</div>
                </section>
            </div>
        </React.Fragment>
    );
}

// separator style
const dividerStyle = {
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.4)'
};

// Default Props
OrderSummary.defaultProps = {
    subTotal: 0,
    totalQty: 0,
    tax: 20,
    bookingFees: 14.1,
    netTotal: 4999.99,
    taxesBreakup: [
        { title: 'IGST (9%)', amount: '₹7.05' },
        { title: 'SGST (9%)', amount: '₹7.05' }
    ],
    bookingBreakup: [
        { title: 'CGST (9%)', amount: '₹7.05' },
        { title: 'SGST (9%)', amount: '₹7.05' }
    ]
};

// will need to work on coupan code section
// [Note]: Fees Amount will be booking fees + platform fees
// [Note]: Show no coupan code found image if there are no coupan code found. if found then show the coupan codes.
// the condition of showing the coupan codes could be if coupanCodes.length > 0 (Need to work on this).
